import React,{useState} from "react";
import "./Contactform.css";
import axios from "axios"
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Contactform = ({reviewSection=false}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [service, setService] = useState("");
  const [city, setCity] = useState("");
  const [town, setTown] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate()

  const formSubmitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post("/send-appointment", {
        email: email,
        name:name,
        service:service,
        phone:phone,
        city:city,
        formType: "Get in Touch",
      })
      .then((response) => {
        if (response.data.msg === "success") {
          setError(false);
          setSuccess("Request for Appointment sended Successfully!");
          setLoading(false);
          setEmail("");
          window.open("/thank-you", '_blank');
        } else if (response.data.msg === "fail") {
          setSuccess(false);
          setError("Failed to send, try again by reloading the page.");
          setLoading(false);
          setEmail("");
        }
      });
  };

  const handlePhoneChange = (e) => {
    // Allow only numeric values and limit the length
    const numericValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
    const maxLength = 20; // Adjust as needed

    // Update state only if the value is within the specified range
    if (numericValue.length <= maxLength) {
      setPhone(numericValue);
    }
  };


  return (
    <div
      className={`contact_section ${!reviewSection && "py-5 "} `}
    >
      <div className="overlay"></div>
      <div className={`container ${!reviewSection ? "py-4 ":"pt-5"} `}>
        <div className="row gy-4 gx-lg-5 d-flex align-items-center">
          <div className="col-md-6 " >
            <div className="contact-details" >
              {/* <p className="sub-heading-w">Let's Talk</p> */}
              <h2 className="h2_main mb-4 body-heading">
                 Let’s get in touch!
              </h2>
              <p className="para_main">
                Let’s discuss your query and find out what we can do to improve your health.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row gy-4">

              <div className="col-12">
                <form className="contact_form_form_container" onSubmit={formSubmitHandler}> 
                  <div className="row gy-4">
                    <div className="col-md-6 col-12">
                      <input
                        required
                        type="text"
                        value={name}
                        maxLength="40"
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Your Full Name"
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <input
                        required
                        type="tel"
                        value={phone}
                        maxLength="22"
                        onChange={handlePhoneChange}
                        placeholder="Your Phone Number"
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <input
                        required
                        type="email"
                        value={email}
                        maxLength="36"
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Your Email Address"
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <input
                       required
                       type="text"
                       value={service}
                       maxLength="70"
                       onChange={(e) => setService(e.target.value)}
                        placeholder="Body Part To Be Treated"
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <input
                       required
                       type="text"
                       value={city}
                       maxLength="200"
                       onChange={(e) => setCity(e.target.value)}
                        placeholder="City/Town"
                      />
                    </div>
                   
                  </div>
                  <div className="row mt-3">
                    <div className="col-12 button_col d-flex align-items-center justify-content-start">
                      <button type="submit"  disabled={loading} className="form-btn">SUBMIT
                      </button>
                      {loading ? (
                          <Spinner
                            animation="border"
                            role="status"
                            style={{ color: "white",marginLeft:"10px" }}
                          />
                    ) : (
                      success ? (
                        <div>
                          {setLoading(false)}
                          {/* {alert(success)} */}
                          {setSuccess(false)}
                        </div>
                      ) : (
                        error && (
                          <div>
                            {setLoading(false)}
                            {alert(error)}
                            {setError(false)}
                          </div>
                        )
                      )
                    )}
                      
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contactform;
